// extracted by mini-css-extract-plugin
export default {"header__nav":"Nav_header__nav__nt5a5","header__list":"Nav_header__list__QE4Oy","header__link":"Nav_header__link__d-Tmg"};